<template>
  <div>

    <header id="header">
      <router-link class="logo" :to="{ name: 'Start'}">
        <img src="/projects/hetfruit/templates/customerportal/images/logo.png" height="60">
      </router-link>
      <h3>Login met je pincode</h3>
    </header>

    <div class="login-container">
      <flash-message ref="flashmessage"></flash-message>

      <input type="number" autofocus="autofocus" maxlength="1" ref="pincode1" v-model="pincode1" @keyup="moveToNext($event,'pincode2')"/>
      <input type="number" maxlength="1" ref="pincode2" v-model="pincode2" @keyup="moveToNext($event,'pincode3')"/>
      <input type="number" maxlength="1" ref="pincode3" v-model="pincode3" @keyup="moveToNext($event,'pincode4')"/>
      <input type="number" maxlength="1" ref="pincode4" v-model="pincode4" @keyup="loginSubmit"/>
    </div>
  </div>
</template>

<script>
import ErrorHelper from "../helpers/ErrorHelper";
import FlashMessage from "../components/FlashMessage";
import {SimpleStore} from "../simplestore";

export default {
  name: "Login",
  components: {FlashMessage},
  data() {
    return {
      pincode1: '',
      pincode2: '',
      pincode3: '',
      pincode4: '',
    };
  },
  mounted() {
    this.$refs.pincode1.focus();

    if (window.localStorage.getItem("loggedin") === 'true') {
      fetch('?action=logout', {
        method: "GET",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",
        },
      }).then(() => {
        window.localStorage.removeItem("loggedin");
        window.localStorage.removeItem("username");
      });
    }
  },
  methods: {

    loginSubmit() {
      fetch('?action=loginwithpincode', {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          "Accept": "application/json",   // expected data sent back
        },
        body: JSON.stringify({
          pincode: this.pincode1.toString() + this.pincode2.toString() + this.pincode3.toString() + this.pincode4.toString(),
        })
      }).then(res => res.json()).then((response) => {
        if (ErrorHelper.handleError(this, response)) {
          this.$refs.flashmessage.refresh();
          this.pincode1 = this.pincode2 = this.pincode3 = this.pincode4 = '';
          this.$refs.pincode1.focus();
        }
        else {
          window.localStorage.setItem("loggedin", 'true');
          window.localStorage.setItem("username", response.data?.username);
          SimpleStore.username = response.data?.username;
          this.$router.push({name: 'Start'});
        }
      }).catch((error) => {
        this.errors = [];
        this.errors.push("Server fout opgetreden. Probeer het later nog eens, of neem contact op (" + error + ")");
      });
    },

    moveToNext: function (field, nextFieldID) {
      if (field.target.value.length == 1) {
        this.$refs[nextFieldID].focus();
      }
    }

  },
}

</script>

<style scoped>
.login-container {
  text-align: center;
}
input {
  padding:    10px;
  border:     1px solid #ddd;
  width:      80px;
  height:     80px;
  text-align: center;
  font-size:  30px;
}
</style>
